import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../services/authContext';
import '../css/sg-platform.css';
import '../css/sg-login.css';
import '../css/sg-popup.css';
import '../css/sg-newuser.css';
import logo from '../assets/sustaingrowth.png';
import PopupPwdRcv from '../components/PopupPwdRcv';
import PopupThankYou from '../components/PopupThankYou';

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [isPwdPopupOpen, setIsPwdPopupOpen] = useState(false);
  const [isThankYouPopupOpen, setIsThankYouPopupOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);

  const openPwdPopup = () => setIsPwdPopupOpen(true);

  const closePwdPopup = () => {
    setIsPwdPopupOpen(false);
    setErrorMessages([]); // Faz reset aos erros ao fechar o popup.
  };

  // Simula o envio do e-mail - substituir com lógica real.
  const handleEmailSubmit = (email) => {
    setIsPwdPopupOpen(false); // Fecha o popup de recuperação.
    setIsThankYouPopupOpen(true); // Abre o popup de agradecimento.

    // Fecha o popup de agradecimento após 5 segundos.
    setTimeout(() => {
      setIsThankYouPopupOpen(false);
    }, 5000);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    const errors = [];

    // Validação manual de e-mail.
    if (!/^[\w.-]+@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
      errors.push('Por favor, insira um e-mail válido.');
    }

    // Validação manual de senha.
    if (password.length < 6) {
      errors.push('A senha deve ter pelo menos 6 caracteres.');
    }

    if (errors.length === 0) {
      try {
        const loginSuccess = await login(email, password);
        if (loginSuccess) {
          navigate('/dashboard');
        } else {
          errors.push('Por favor, tente novamente.');
        }
      } catch (error) {
        errors.push('E-mail ou senha incorretos.');
      }
    }

    // Atualizar mensagens de erro se houver
    setErrorMessages(errors);
  };

  return (
    <div className="body">
      <div className="wrapper">
        <div className="logo-container">
          <img className="logo" src={logo} alt="Logótipo SustainGrowth" />
        </div>
        <form onSubmit={handleLogin}>
          <div className="input-box">
            <input
              type="email"
              placeholder="E-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={
                errorMessages.some((msg) => msg.includes('e-mail'))
                  ? 'error'
                  : ''
              }
            />
            <i className="fa-solid fa-envelope"></i>
          </div>
          <div className="input-box">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={
                errorMessages.some((msg) => msg.includes('senha'))
                  ? 'error'
                  : ''
              }
            />
            <i className="fa-solid fa-lock"></i>
          </div>

          {/* -- Checkbox de memorização e link de recuperação de senha -- */}

          <div className="remember-forgot">
            <label>
              <input type="checkbox" /> Memorizar
            </label>
            <button
              type="button"
              id="forgot-password"
              onClick={openPwdPopup}
              className="link-button"
            >
              Esqueci-me password?
            </button>
          </div>

          {/* -- Link de New User -- */}

          <div className="btn-container">
            <button type="submit" className="btn">
              Entrar<i className="fa-solid fa-angle-right"></i>
            </button>
          </div>
          <div className="register-link">
            <p className="p2">
              Não tem conta? <Link to="/NewUser">Registar!</Link>
            </p>
          </div>
        </form>

        {/* -- Mensagens de erro exibidas no final do container -- */}

        {errorMessages.length > 0 && (
          <div className="error-messages-wrapper">
            <ul>
              {errorMessages.map((error, index) => (
                <li key={index} className="error-message">
                  {error}
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="powered">
          <p>
            Powered by <a href="https://www.sfcolab.org/">SFCOLAB</a>.
          </p>
        </div>

        {/* Popup de recuperação de senha */}

        {isPwdPopupOpen && (
          <PopupPwdRcv
            title="Recuperação de Password"
            content={
              <p>
                Insira o seu e-mail para receber instruções de recuperação de
                password:
              </p>
            }
            onClose={closePwdPopup}
            handleEmailSubmit={handleEmailSubmit}
          />
        )}

        {/* Popup de agradecimento */}

        {isThankYouPopupOpen && (
          <PopupThankYou
            title="Email Enviado!"
            content={<p>Instruções enviadas para o seu e-mail com sucesso.</p>}
            onClose={() => setIsThankYouPopupOpen(false)}
          />
        )}
      </div>
    </div>
  );
}

export default Login;
